import React from "react";
import Paper from "@material-ui/core/Paper";
import Style from "../../styles/js/Styles";
import { List, ListItem, withStyles } from "@material-ui/core";

export default function ListAlerts({ users, clickOnMarker }) {
  const style = Style();

  const [selectedIndex, setSelectedIndex] = React.useState(-1);

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };

  const handleClick = (index, user) => {
    handleListItemClick(index);
    clickOnMarker(user);
  };

  const ok = {
    background: '#b0efd199',
  };

  const bitoudated = {
    background: '#f0dec999',
  };

  const moving = {
    background: '#ff8ca499',
  };

  const nodata = {
    background: '#77777755',
  };

  return (
    <Paper className={style.listAlerts}>
      <div className={style.titlePaper}> Personas Aisladas </div>
      <List component="nav" aria-label="main mailbox folders">
        {users !== undefined &&
          users.map((user, index) => (
              <ListItem
                button
                style={ user.isMoving() ? moving : (!user.hasLocation() || user.isOutDated()) ? nodata : user.isUpdated() ? ok : bitoudated}
                selected={selectedIndex === index}
                onClick={() => handleClick(index, user)}
              >
                {user.profile.name} {user.profile.lastName}
              </ListItem>)
          )}
      </List>
    </Paper>
  );
}
